import React, { useRef } from 'react';
import { useAuthContext } from '@hooks/use-auth-context';
import {
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingsButton,
} from '@views/Settings/components';
import styles from './CancelPlan.module.scss';
import { useWorkspaceContext } from '@support/hooks/use-workspace-context';
import { getPlanType } from '../ManagePlan';
import { UserSession } from '@app/types';

export const openChurnkeyModal = ({
  user,
  switchingToPersonalPlan = false,
}: {
  user: UserSession;
  switchingToPersonalPlan?: boolean;
}) => {
  window.churnkey.init('show', {
    customerId: user?.stripe_customer_id,
    authHash: user?.churnkey,
    appId: 'cm3qlq54x',
    mode: 'live', // set to 'test' to hit test billing provider environment
    provider: 'stripe',
    record: true, // set to false to skip session playback recording
    customerAttributes: { switchingToPersonalPlan },
  });
};

const CancelPlanButton = () => {
  const { user } = useAuthContext();
  const startCancelPlanFlow = () => openChurnkeyModal({ user });

  return (
    <SettingsButton onClick={startCancelPlanFlow} className={styles.btn} isInsideBox>
      Cancel Plan
    </SettingsButton>
  );
};

export default function CancelPlan() {
  const workspaceCtx = useWorkspaceContext();
  const authCtx = useAuthContext();
  const planType = useRef(getPlanType(authCtx));
  const userIsAdmin = useRef(workspaceCtx.activeWorkspace && !workspaceCtx.userIsAdmin);
  const user = authCtx.user;
  const featuresStr = 'all paid features';

  if (planType.current === 'free' || !userIsAdmin) {
    return null;
  }

  if (!user || user.billing_provider !== 'Stripe' || !user.churnkey || !user.stripe_customer_id) {
    return null;
  }

  return (
    <Section>
      <SettingsSectionLabel>Cancel Plan</SettingsSectionLabel>
      <SettingsSectionBox className={styles.box}>
        Cancel my plan
        <CancelPlanButton />
        <p>
          When canceling, you'll lose access to{' '}
          {window.desktopIntegrations?.appInfo.isMAS ? (
            <>{featuresStr}</>
          ) : (
            <a href="https://clay.earth/pricing" target="_blank">
              {featuresStr}
            </a>
          )}
          .
        </p>
      </SettingsSectionBox>
    </Section>
  );
}
